import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import IdleLogout from './IdleLogout';

// One shell for every authenticated page. Pages render only their content.
export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < 900
  );

  useEffect(() => {
    const onResize = () => setCollapsed(window.innerWidth < 900);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <div className="app-shell-with-sidebar ops-shell">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(c => !c)} />
      <Outlet />
      <IdleLogout />
    </div>
  );
}
